import styled from 'styled-components';
import { PlayCircleFilled } from '@ant-design/icons';

import React, { useState, useRef, useEffect } from 'react';

interface Props {
  src: string;
}

const CustomVideoPlayer: React.FC<Props> = ({ src }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  // Cleanup: pause and reset video when component unmounts
  useEffect(() => {
    return () => {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
        videoRef.current.src = '';
      }
    };
  }, []);

  return (
    <VideoWrapper>
      <StyledVideo
        ref={videoRef}
        src={src}
        controls={isPlaying} // Hiện thanh công cụ mặc định sau khi đã bấm Play
        onPause={() => setIsPlaying(false)}
      />

      {!isPlaying && (
        <Overlay onClick={togglePlay}>
          <StyledPlayIcon className='play-icon' />
        </Overlay>
      )}
    </VideoWrapper>
  );
};

export default CustomVideoPlayer;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 765px;
  object-fit: cover;
  display: block;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.5);
    .play-icon {
      transform: scale(1.1);
      opacity: 1;
    }
  }
`;

const StyledPlayIcon = styled(PlayCircleFilled)`
  font-size: 64px;
  color: #ffffff;
  opacity: 0.8;
  transition: all 0.3s ease;
`;
